import { normalizeCognitoAttributes } from './cognito-user.js';

function toDisplayName(givenName, familyName, fallback = '') {
  const name = [givenName, familyName]
    .filter(Boolean)
    .join(' ')
    .trim();
  return name || fallback;
}

function toDisplayDate(value) {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }
  return date.toLocaleString('en-US');
}

function escapeCsvValue(value) {
  const stringValue =
    value === null || typeof value === 'undefined' ? '' : String(value);
  const escaped = stringValue.replace(/"/g, '""');
  return /[",\n\r]/.test(escaped) ? `"${escaped}"` : escaped;
}

function formatCsvRow(values = []) {
  return values.map(escapeCsvValue).join(',');
}

export function buildCognitoAgreementReportQuery({
  tenantId = false,
  acceptedFrom = false,
  acceptedTo = false,
} = {}) {
  const params = new URLSearchParams();
  if (tenantId) {
    params.set('tenant_id', tenantId);
  }
  if (acceptedFrom) {
    params.set('accepted_from', acceptedFrom);
  }
  if (acceptedTo) {
    params.set('accepted_to', acceptedTo);
  }
  return params.toString();
}

export function normalizeCognitoAgreementReportRecord(record = {}) {
  const attributes = normalizeCognitoAttributes(
    record.Attributes || record.attributes
  );
  const givenName =
    attributes.given_name || record.given_name || record.first_name || '';
  const familyName =
    attributes.family_name || record.family_name || record.last_name || '';
  const agreementStatement =
    attributes['custom:copyright_statement'] ||
    record.agreement_statement ||
    record.copyright_statement ||
    '';

  return {
    ...record,
    id: record.id || record.Username || record.username || '',
    username: record.username || record.Username || record.id || '',
    tenant: attributes['custom:tenant'] || record.tenant || '',
    given_name: givenName,
    family_name: familyName,
    full_name: toDisplayName(
      givenName,
      familyName,
      record.full_name || record.name || ''
    ),
    email: attributes.email || record.email || '',
    accepted_at: record.accepted_at || record.UserCreateDate || '',
    accepted_at_display: toDisplayDate(
      record.accepted_at || record.UserCreateDate || ''
    ),
    agreement_statement: agreementStatement,
    acknowledgement:
      attributes['custom:acknowledgement'] || record.acknowledgement || '',
    attributes,
  };
}

export function buildCognitoAgreementReportCsv(rows = []) {
  const header = [
    'Tenant',
    'User Full Name',
    'User Email',
    'Date Accepted',
    'Agreement Statement',
    'Acknowledgement',
  ];
  const dataRows = Array.isArray(rows) ? rows : [];
  const lines = [formatCsvRow(header)];

  dataRows.forEach(row => {
    const normalized = normalizeCognitoAgreementReportRecord(row);
    lines.push(
      formatCsvRow([
        normalized.tenant,
        normalized.full_name,
        normalized.email,
        normalized.accepted_at_display,
        normalized.agreement_statement,
        normalized.acknowledgement,
      ])
    );
  });

  return lines.join('\r\n');
}
